import { Module } from 'wrapper6'

const $ = jQuery

export default class Tabs extends Module {
  ready (app) {
    this.addTabClicks()
  }

  addTabClicks () {
    const tabs = document.querySelectorAll('.mtt-tabs-widget__tab')

    if (tabs.length) {
      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i]

        tab.addEventListener('click', () => {
          const id = tab.getAttribute('data-id')
          const wrapper = this.findAncestor(tab, '.mtt-tabs-widget')

          wrapper.querySelector('.mtt-tabs-widget__tab.active').classList.remove('active')

          tab.classList.add('active')

          wrapper.querySelector('.mtt-tabs-widget__widget:not(.hide)').classList.add('hide')

          wrapper.querySelector('.mtt-tabs-widget__widget[data-id="' + id + '"]').classList.remove('hide')

          $([document.documentElement, document.body]).animate({
            scrollTop: $(wrapper).offset().top
          }, 500)
        })
      }
    }
  }

  findAncestor (el, selector) {
    let parent_container = el
    do {
      parent_container = parent_container.parentNode
    }
    while (!parent_container.matches(selector) && parent_container !== document.body)

    return parent_container
  }
}
